<template>
  <div class="article-record">
    <ul>
      <li
        v-for="(item,index) in dataList"
        :key="index+'li'"
        :class="isLi==item.name?'li-sty li-check-sty':'li-sty'"
        @click="oncheckLi(item)"
      >{{item.name}}</li>
    </ul>
    <div class="data-list" v-for="(item,index) in dataList" :key="index">
      <div class="list-scroll" v-if="item.name=='全部' && isLi==item.name">
        <div v-for="(con,i) in item.value" :key="i+con">
          <!-- 文章 -->
          <div class="article-div" v-if="con.contentType=='ART'">
            <div class="list-time">2022年5月9日 14:33</div>
            <div class="home-list-sty">
              <div class="list-left">
                <img :src="con.coverLink" alt />
              </div>
              <div class="list-right">
                <div class="list-r-tit" @click="goToDetails(con.artcId,item.coverLink)">
                  <!-- <img src="./img/home_name0.png" alt /> -->
                  <svg-icon icon-class="home_name2"></svg-icon>
                  <span>{{con.title}}</span>
                </div>
                <div class="list-r-foot">
                  <span>浏览 {{con.viewCount || 0}} 次</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 图文 -->
          <div class="imgs-div" v-if="con.contentType=='PAW'">
            <div class="list-time">2022年5月9日 14:33</div>
            <div class="list-r-tit">
              <!-- <img src="./img/home_name1.png" alt /> -->
              <svg-icon icon-class="home_name1"></svg-icon>
              <span>{{con.artcSummary}}</span>
            </div>
            <div class="home-imgList-sty">
              <!-- 图片大于一张 并且不是四张 -->
              <div v-if="con.imgurl.length!=4" class="home-isImg">
                <div
                  v-for="(it,ind) in con.imgurl"
                  :key="ind+'0'"
                  :class="con.imgurl.length > 1 && con.imgurl.length!=4 ? 'home-img-size home-img-size2':'home-img-size'"
                >
                  <div>
                    <van-image
                      @click="seeImg(con,$event)"
                      v-if="it"
                      width="100%"
                      height="100%"
                      :src="it"
                    />
                  </div>
                </div>
              </div>
              <!-- 图片是四张 -->
              <div v-if="con.imgurl.length==4" class="home-isImg">
                <div v-for="(it,ind) in con.imgurl" :key="ind+'1'" class="home-img-size4">
                  <div>
                    <van-image
                      @click="seeImg(con,$event)"
                      v-if="it"
                      width="100%"
                      height="100%"
                      :src="it"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="list-r-foot list-igm-foot">
              <span>浏览 {{con.viewCount || 0}} 次</span>
            </div>
          </div>
          <!-- 视频 -->
          <div class="Video-div" v-if="con.contentType=='VOD'">
            <div class="list-r-tit">
              <!-- <img src="./img/home_name2.png" alt /> -->
              <svg-icon icon-class="home_name3"></svg-icon>
              <span>{{con.vtitle}}</span>
            </div>
            <div class="home-imgList-sty">
              <div class="home-img-size">
                <div>
                  <van-image
                    @click="goToVideo('inner',con.artcId)"
                    width="100%"
                    height="100%"
                    :src="con.faceImgUrl || con.imgUrl1"
                  />
                </div>
              </div>
            </div>
            <div class="list-r-foot list-igm-foot">
              <span>浏览 {{con.viewCount || 0}}次</span>
            </div>
          </div>
        </div>
      </div>
      <div class="list-scroll" v-if="item.name=='文章' && isLi==item.name">
        <div class="article-div" v-for="(con,i) in item.value" :key="i+con">
          <div class="list-time">2022年5月9日 14:33</div>
          <div class="home-list-sty">
            <div class="list-left">
              <img :src="con.coverLink" alt />
            </div>
            <div class="list-right">
              <div class="list-r-tit" @click="goToDetails(con.artcId,item.coverLink)">
                <!-- <img src="./img/home_name0.png" alt /> -->
                <svg-icon icon-class="home_name2"></svg-icon>
                <span>{{con.title}}</span>
              </div>
              <div class="list-r-foot">
                <span>浏览 {{con.viewCount || 0}} 次</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="list-scroll" v-if="item.name=='图文' && isLi==item.name">
        <div class="imgs-div" v-for="(con,i) in item.value" :key="i+con">
          <div class="list-time">2022年5月9日 14:33</div>
          <div class="list-r-tit">
            <!-- <img src="./img/home_name1.png" alt /> -->
            <svg-icon icon-class="home_name1"></svg-icon>
            <span>{{con.artcSummary}}</span>
          </div>
          <div class="home-imgList-sty">
            <!-- 图片大于一张 并且不是四张 -->
            <div v-if="con.imgurl.length!=4" class="home-isImg">
              <div
                v-for="(it,ind) in con.imgurl"
                :key="ind+'0'"
                :class="con.imgurl.length > 1 && con.imgurl.length!=4 ? 'home-img-size home-img-size2':'home-img-size'"
              >
                <div>
                  <van-image
                    @click="seeImg(con,$event)"
                    v-if="it"
                    width="100%"
                    height="100%"
                    :src="it"
                  />
                </div>
              </div>
            </div>
            <!-- 图片是四张 -->
            <div v-if="con.imgurl.length==4" class="home-isImg">
              <div v-for="(it,ind) in con.imgurl" :key="ind+'1'" class="home-img-size4">
                <div>
                  <van-image
                    @click="seeImg(con,$event)"
                    v-if="it"
                    width="100%"
                    height="100%"
                    :src="it"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="list-r-foot list-igm-foot">
            <span>浏览 {{con.viewCount || 0}} 次</span>
          </div>
        </div>
      </div>
      <div class="list-scroll" v-if="item.name=='视频' && isLi==item.name">
        <div class="Video-div" v-for="(con,i) in item.value" :key="i+con">
          <div class="list-time">2022年5月9日 14:33</div>
          <div class="list-r-tit">
            <!-- <img src="./img/home_name2.png" alt /> -->
            <svg-icon icon-class="home_name3"></svg-icon>
            <span>{{con.vtitle}}</span>
          </div>
          <div class="home-imgList-sty">
            <div class="home-img-size">
              <div>
                <van-image
                  @click="goToVideo('inner',con.artcId)"
                  width="100%"
                  height="100%"
                  :src="con.faceImgUrl || con.imgUrl1"
                />
              </div>
            </div>
          </div>
          <div class="list-r-foot list-igm-foot">
            <span>浏览 {{con.viewCount || 0}}次</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLi: '全部',
      dataList: [
        {
          name: '全部', value: [
            {
              contentType: "PAW", artcSummary: "测试一下", imgurl: [
                'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png',
                'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png',
                'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png',
                'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png',
                'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png',
              ], time: '2022年5月9日 14:33', viewCount: '10'
            },
            { contentType: "ART", coverLink: 'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png', title: "大爷偷拍大白火了", imgurl: [], time: '2022年5月9日 14:33', viewCount: '10' },
            { contentType: "ART", coverLink: 'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png', title: "大爷偷拍大白火了大爷偷拍大白火了大爷偷拍大白火了大爷偷拍大白火了大爷偷拍大白火了", imgurl: [], time: '2022年5月9日 14:33', viewCount: '10' },
            { contentType: "VOD", faceImgUrl: 'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png', vtitle: "8888", imgurl: [], time: '2022年5月9日 14:33', viewCount: '10' },
          ]
        },
        {
          name: '文章', value: [
            { contentType: "ART", coverLink: 'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png', title: "大爷偷拍大白火了", imgurl: [], time: '2022年5月9日 14:33', viewCount: '10' },
            { contentType: "ART", coverLink: 'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png', title: "大爷偷拍大白火了", imgurl: [], time: '2022年5月9日 14:33', viewCount: '10' },
            { contentType: "ART", coverLink: 'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png', title: "大爷偷拍大白火了", imgurl: [], time: '2022年5月9日 14:33', viewCount: '10' },
          ]
        },
        {
          name: '图文', value: [
            {
              contentType: "PAW", artcSummary: "测试一下", imgurl: [
                'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png',
                'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png',
              ], time: '2022年5月9日 14:33', viewCount: '10'
            },
          ]
        },
        {
          name: '视频', value: [
            { contentType: "VOD", faceImgUrl: 'https://dtfcloud.com/skjy/6a6bacfa-fb82-461c-9cf8-b8d166f06fec.png', vtitle: "8888", imgurl: [], time: '2022年5月9日 14:33', viewCount: '10' },
          ]
        },
      ]
    }
  },
  methods: {
    oncheckLi(item) {
      this.isLi = item.name
    }
  }
}
</script>

<style lang="less" scoped>
.article-record {
  font-weight: 500;
  ul {
    width: 355px;
    margin: auto;
    display: flex;
    font-size: 11px;
    font-weight: 400;
    .li-sty {
      width: 60px;
      height: 20px;
      line-height: 20px;
      margin-top: 15px;
      text-align: center;
      background: url("../../assets/publicImg/li-bg6.png") no-repeat 100%;
      background-size: 100% 100%;
      color: #666666;
      &:not(:first-child) {
        margin-left: 10px;
      }
    }
    .li-check-sty {
      font-weight: 500;
      color: #fc6e09;
    }
  }
  .data-list {
    font-size: 11px;
    font-weight: 400;
    .list-scroll{
      height: calc(100vh - 140px);
      overflow: scroll;
    }
    .svg-icon {
      width: 28px;
      height: 17px;
    }
    .article-div {
      width: 355px;
      height: 100px;
      margin: 15px auto auto;

      color: #333333;
      background: url("../../assets/publicImg/con-bg.png") no-repeat 100%;
      background-size: 100% 100%;
      .list-time {
        padding: 8px 5px;
      }
      .home-list-sty {
        display: flex;
        .list-left {
          width: 95px;
          height: 58px;
          margin-left: 5px;
          border: 1px solid;
          img {
            width: 100%;
          }
        }
        .list-right {
          width: 260px;
          padding-left: 15px;
          .list-r-tit {
            height: 30px;
            display: flex;
            span {
              width: 197px;
              padding-left: 8px;
              font-weight: 500;
              display: -webkit-box;
              overflow: hidden;
              -webkit-line-clamp: 2;
              word-break: break-all;
              -webkit-box-orient: vertical;
            }
          }
          .list-r-foot {
            margin-top: 10px;
            span {
              font-size: 9px;
              color: #999999;
            }
          }
        }
      }
    }
    .imgs-div {
      width: 355px;
      margin: 15px auto auto;
      .list-r-tit {
        display: block;
        display: flex;
        span {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          padding-left: 10px;
        }
      }
      .list-r-foot {
        span {
          font-size: 9px;
          color: #999999;
        }
      }
      .home-imgList-sty {
        width: 100%;
        margin: 9px auto 9px auto;
        .home-isImg {
          display: flex;
          flex-wrap: wrap;
        }
        .home-img-size {
          width: 100%;
        }
        .home-img-size2 {
          width: 110px;
          height: 64px;
          margin-top: 5px;
        }
        .home-img-size2:nth-child(n) {
          margin-right: 7.5px;
        }
        .home-img-size2:nth-child(3n) {
          margin: 0;
        }
        .home-img-size4 {
          width: 40%;
          margin-right: 7.5px;
        }
      }
    }
    .Video-div {
      width: 355px;
      margin: 15px auto auto;
    }
  }
}
</style>